export default __webpack_public_path__ + "static/media/91_mobile.ee52cb84.jpg";